import customReportService from "../shared/services/customReportService";
import fileDownload from "js-file-download";

const REQUEST_CREATE_CUSTOM_REPORT = "REQUEST_CREATE_CUSTOM_REPORT";
const RESPONSE_CREATE_CUSTOM_REPORT = "RESPONSE_CREATE_CUSTOM_REPORT";
const REQUEST_CREATE_CUSTOM_REPORT_FAILURE = "REQUEST_CREATE_CUSTOM_REPORT_FAILURE";

const requestCreateCustomReportAction = () => {
  return {
    type: REQUEST_CREATE_CUSTOM_REPORT,
  };
};

const responseCreateCustomReportAction = (data) => {
  return {
    type: RESPONSE_CREATE_CUSTOM_REPORT,
    data,
  };
};

const requestCreateCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const createCustomReport = (options) => {
  return (dispatch) => {
    dispatch(requestCreateCustomReportAction());

    customReportService
      .createCustomReport(options)
      .then((result) => {
        dispatch(responseCreateCustomReportAction(result.data));
      })
      .catch((error) => {
        dispatch(requestCreateCustomReportFailureAction(error.response));
      });
  };
};

const SELECT_CUSTOM_REPORT = "SELECT_CUSTOM_REPORT";

const selectedCustomReportActions = (data) => {
  return {
    type: SELECT_CUSTOM_REPORT,
    data,
  };
};

const selectedCustomReport = (id) => {
  return (dispatch) => {
    dispatch(selectedCustomReportActions(id));
  };
};

const UNSELECT_CUSTOM_REPORT = "UNSELECT_CUSTOM_REPORT";

const unselectedCustomReportActions = () => {
  return {
    type: UNSELECT_CUSTOM_REPORT,
  };
};

const unselectedCustomReport = (options) => {
  return (dispatch) => {
    dispatch(unselectedCustomReportActions());
  };
};

const REQUEST_DELETE_CUSTOM_REPORT = "REQUEST_DELETE_CUSTOM_REPORT";
const RESPONSE_DELETE_CUSTOM_REPORT = "RESPONSE_DELETE_CUSTOM_REPORT";
const REQUEST_DELETE_CUSTOM_REPORT_FAILURE = "REQUEST_DELETE_CUSTOM_REPORT_FAILURE";

const requestDeleteCustomReportAction = () => {
  return {
    type: REQUEST_DELETE_CUSTOM_REPORT,
  };
};

const responseDeleteCustomReportAction = (data) => {
  return {
    type: RESPONSE_DELETE_CUSTOM_REPORT,
    data,
  };
};

const requestDeleteCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const deleteCustomReport = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteCustomReportAction());

    customReportService
      .deleteCustomReport(options)
      .then((result) => {
        dispatch(responseDeleteCustomReportAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_CUSTOM_REPORT_TITLE = "REQUEST_UPDATE_CUSTOM_REPORT_TITLE";
const RESPONSE_UPDATE_CUSTOM_REPORT_TITLE = "RESPONSE_UPDATE_CUSTOM_REPORT_TITLE";
const REQUEST_UPDATE_CUSTOM_REPORT_TITLE_FAILURE = "REQUEST_UPDATE_CUSTOM_REPORT_TITLE";

const requestUpdateCustomReportTitleAction = () => {
  return {
    type: REQUEST_UPDATE_CUSTOM_REPORT_TITLE,
  };
};

const responseUpdateCustomReportTitleAction = (data) => {
  return {
    type: RESPONSE_UPDATE_CUSTOM_REPORT_TITLE,
    data,
  };
};

const requestUpdateCustomReportTitleFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_CUSTOM_REPORT_TITLE_FAILURE,
    errors,
  };
};

const updateCustomReportTitle = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateCustomReportTitleAction());

    customReportService
      .updateCustomReportTitle(options)
      .then((result) => {
        dispatch(responseUpdateCustomReportTitleAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateCustomReportTitleFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT = "REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT";
const RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT = "RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT";
const REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT_FAILURE = "REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT_FAILURE";

const requestDeleteDashboardCustomReportAction = () => {
  return {
    type: REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT,
  };
};

const responseDeleteDashboardCustomReportAction = (reportId, id, data) => {
  return {
    type: RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT,
    reportId,
    id,
    data,
  };
};

const requestDeleteDashboardCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const deleteCustomReportDahsboard = (options, reportId) => {
  return (dispatch) => {
    dispatch(requestDeleteDashboardCustomReportAction());

    customReportService
      .deleteCustomReportDashboard(options)
      .then((result) => {
        dispatch(responseDeleteDashboardCustomReportAction(reportId, options.id, result.data));
      })
      .catch((error) => {
        dispatch(requestDeleteDashboardCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT = "REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT";
const RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT = "RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT";
const REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT_FAILURE = "REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT_FAILURE";

const requesShiftDashboardCustomReportAction = () => {
  return {
    type: REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT,
  };
};

const responseShiftDashboardCustomReportAction = (reportId, id, data) => {
  return {
    type: RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT,
    reportId,
    id,
    data,
  };
};

const requestShiftDashboardCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const shiftCustomReportDahsboard = (options, reportId) => {
  return (dispatch) => {
    dispatch(requesShiftDashboardCustomReportAction());

    customReportService
      .shiftCustomReportDashboard(options)
      .then((result) => {
        dispatch(responseShiftDashboardCustomReportAction(reportId, options.id, result.data));
      })
      .catch((error) => {
        dispatch(requestShiftDashboardCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT = "REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT";
const RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT = "RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT";
const REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT_FAILURE = "REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT_FAILURE";

const requesUpdateDashboardCustomReportAction = () => {
  return {
    type: REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT,
  };
};

const responseUpdateDashboardCustomReportAction = (reportId, data) => {
  return {
    type: RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT,
    reportId,
    data,
  };
};

const requestUpdateDashboardCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const updateCustomReportDashboard = (options, reportId) => {
  return (dispatch) => {
    dispatch(requesUpdateDashboardCustomReportAction());

    customReportService
      .updateCustomReportDashboard(options)
      .then((result) => {
        dispatch(responseUpdateDashboardCustomReportAction(reportId, options));
      })
      .catch((error) => {
        dispatch(requestUpdateDashboardCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_ADD_DASHBOARD_CUSTOM_REPORT = "REQUEST_ADD_DASHBOARD_CUSTOM_REPORT";
const RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT = "RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT";
const REQUEST_ADD_DASHBOARD_CUSTOM_REPORT_FAILURE = "REQUEST_ADD_DASHBOARD_CUSTOM_REPORT_FAILURE";

const requesAddDashboardCustomReportAction = () => {
  return {
    type: REQUEST_ADD_DASHBOARD_CUSTOM_REPORT,
  };
};

const responseAddDashboardCustomReportAction = (reportId, data) => {
  return {
    type: RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT,
    reportId,
    data,
  };
};

const requestAddDashboardCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_DASHBOARD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const addCustomReportDashboard = (options) => {
  return (dispatch) => {
    dispatch(requesAddDashboardCustomReportAction());

    customReportService
      .createCustomReportDashboard(options)
      .then((result) => {
        dispatch(responseAddDashboardCustomReportAction(options.reportId, result.data));
      })
      .catch((error) => {
        dispatch(requestAddDashboardCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_FIELD_CUSTOM_REPORT = "REQUEST_DELETE_FIELD_CUSTOM_REPORT";
const RESPONSE_DELETE_FIELD_CUSTOM_REPORT = "RESPONSE_DELETE_FIELD_CUSTOM_REPORT";
const REQUEST_DELETE_FIELD_CUSTOM_REPORT_FAILURE = "REQUEST_DELETE_FIELD_CUSTOM_REPORT_FAILURE";

const requestDeleteFieldCustomReportAction = () => {
  return {
    type: REQUEST_DELETE_FIELD_CUSTOM_REPORT,
  };
};

const responseDeleteFieldCustomReportAction = (reportId, id, data) => {
  return {
    type: RESPONSE_DELETE_FIELD_CUSTOM_REPORT,
    reportId,
    id,
    data,
  };
};

const requestDeleteFieldCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_FIELD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const deleteCustomReportField = (options, reportId) => {
  return (dispatch) => {
    dispatch(requestDeleteFieldCustomReportAction());

    customReportService
      .deleteCustomReportField(options)
      .then((result) => {
        dispatch(responseDeleteFieldCustomReportAction(reportId, options.id, result.data));
      })
      .catch((error) => {
        dispatch(requestDeleteFieldCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_ADD_FIELD_CUSTOM_REPORT = "REQUEST_ADD_FIELD_CUSTOM_REPORT";
const RESPONSE_ADD_FIELD_CUSTOM_REPORT = "RESPONSE_ADD_FIELD_CUSTOM_REPORT";
const REQUEST_ADD_FIELD_CUSTOM_REPORT_FAILURE = "REQUEST_ADD_FIELD_CUSTOM_REPORT_FAILURE";

const requesAddFieldCustomReportAction = () => {
  return {
    type: REQUEST_ADD_FIELD_CUSTOM_REPORT,
  };
};

const responseAddFieldCustomReportAction = (reportId, data) => {
  return {
    type: RESPONSE_ADD_FIELD_CUSTOM_REPORT,
    reportId,
    data,
  };
};

const requestAddFieldCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_FIELD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const addCustomReportField = (options) => {
  return (dispatch) => {
    dispatch(requesAddFieldCustomReportAction());

    customReportService
      .createCustomReportField(options)
      .then((result) => {
        dispatch(responseAddFieldCustomReportAction(options.reportId, result.data));
      })
      .catch((error) => {
        dispatch(requestAddFieldCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_FIELD_CUSTOM_REPORT = "REQUEST_UPDATE_FIELD_CUSTOM_REPORT";
const RESPONSE_UPDATE_FIELD_CUSTOM_REPORT = "RESPONSE_UPDATE_FIELD_CUSTOM_REPORT";
const REQUEST_UPDATE_FIELD_CUSTOM_REPORT_FAILURE = "REQUEST_UPDATE_FIELD_CUSTOM_REPORT_FAILURE";

const requesUpdateFieldCustomReportAction = () => {
  return {
    type: REQUEST_UPDATE_FIELD_CUSTOM_REPORT,
  };
};

const responseUpdateFieldCustomReportAction = (reportId, data) => {
  return {
    type: RESPONSE_UPDATE_FIELD_CUSTOM_REPORT,
    reportId,
    data,
  };
};

const requestUpdateFieldCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_FIELD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const updateCustomReportField = (options, reportId) => {
  return (dispatch) => {
    dispatch(requesUpdateFieldCustomReportAction());

    customReportService
      .updateCustomReportField(options)
      .then((result) => {
        dispatch(responseUpdateFieldCustomReportAction(reportId, options));
      })
      .catch((error) => {
        dispatch(requestUpdateFieldCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_SHIFT_FIELD_CUSTOM_REPORT = "REQUEST_SHIFT_FIELD_CUSTOM_REPORT";
const RESPONSE_SHIFT_FIELD_CUSTOM_REPORT = "RESPONSE_SHIFT_FIELD_CUSTOM_REPORT";
const REQUEST_SHIFT_FIELD_CUSTOM_REPORT_FAILURE = "REQUEST_SHIFT_FIELD_CUSTOM_REPORT_FAILURE";

const requesShiftFieldCustomReportAction = () => {
  return {
    type: REQUEST_SHIFT_FIELD_CUSTOM_REPORT,
  };
};

const responseShiftFieldCustomReportAction = (reportId, id, data) => {
  return {
    type: RESPONSE_SHIFT_FIELD_CUSTOM_REPORT,
    reportId,
    id,
    data,
  };
};

const requestShiftFieldCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_SHIFT_FIELD_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const shiftCustomReportField = (options, reportId) => {
  return (dispatch) => {
    dispatch(requesShiftFieldCustomReportAction());

    customReportService
      .shiftCustomReportField(options)
      .then((result) => {
        dispatch(responseShiftFieldCustomReportAction(reportId, options.id, result.data));
      })
      .catch((error) => {
        dispatch(requestShiftFieldCustomReportFailureAction(error.response));
      });
  };
};

const REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT = "REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT";
const RESPONSE_DOWNLOAD_EXAMPLE_CUSTOM_REPORT = "RESPONSE_DOWNLOAD_EXAMPLE_CUSTOM_REPORT";
const REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT_FAILURE = "REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT_FAILURE";

const requestDownloadExampleCustomReportAction = () => {
  return {
    type: REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT,
  };
};

const responseDownloadExampleCustomReportAction = () => {
  return {
    type: RESPONSE_DOWNLOAD_EXAMPLE_CUSTOM_REPORT,
  };
};

const requestDownloadExampleCustomReportFaillureAction = () => {
  return {
    type: REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT_FAILURE,
  };
};

const downloadExampleCustomReport = (options) => {
  return (dispatch) => {
    dispatch(requestDownloadExampleCustomReportAction());
    customReportService
      .downloadExample(options)
      .then((result) => {
        fileDownload(result.data, `Пример отчета ${options.title}.xlsx`);
        dispatch(responseDownloadExampleCustomReportAction());
      })
      .catch((error) => {
        dispatch(requestDownloadExampleCustomReportFaillureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_AXIS_CUSTOM_REPORT = "REQUEST_UPDATE_AXIS_CUSTOM_REPORT";
const RESPONSE_UPDATE_AXIS_CUSTOM_REPORT = "RESPONSE_UPDATE_AXIS_CUSTOM_REPORT";
const REQUEST_UPDATE_AXIS_CUSTOM_REPORT_FAILURE = "REQUEST_UPDATE_AXIS_CUSTOM_REPORT_FAILURE";

const requesUpdateAxisCustomReportAction = () => {
  return {
    type: REQUEST_UPDATE_AXIS_CUSTOM_REPORT,
  };
};

const responseUpdateAxisCustomReportAction = (reportId, data) => {
  return {
    type: RESPONSE_UPDATE_AXIS_CUSTOM_REPORT,
    reportId,
    data,
  };
};

const requestUpdateAxisCustomReportFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_AXIS_CUSTOM_REPORT_FAILURE,
    errors,
  };
};

const updateCustomReportAxis = (options, reportId) => {
  return (dispatch) => {
    dispatch(requesUpdateAxisCustomReportAction());

    customReportService
      .updateCustomReportChartAxis(options)
      .then((result) => {
        dispatch(responseUpdateAxisCustomReportAction(reportId, options));
      })
      .catch((error) => {
        dispatch(requestUpdateAxisCustomReportFailureAction(error.response));
      });
  };
};

export {
  REQUEST_CREATE_CUSTOM_REPORT,
  RESPONSE_CREATE_CUSTOM_REPORT,
  REQUEST_CREATE_CUSTOM_REPORT_FAILURE,
  createCustomReport,
  SELECT_CUSTOM_REPORT,
  selectedCustomReport,
  UNSELECT_CUSTOM_REPORT,
  unselectedCustomReport,
  REQUEST_DELETE_CUSTOM_REPORT,
  RESPONSE_DELETE_CUSTOM_REPORT,
  REQUEST_DELETE_CUSTOM_REPORT_FAILURE,
  deleteCustomReport,
  REQUEST_UPDATE_CUSTOM_REPORT_TITLE,
  RESPONSE_UPDATE_CUSTOM_REPORT_TITLE,
  REQUEST_UPDATE_CUSTOM_REPORT_TITLE_FAILURE,
  updateCustomReportTitle,
  REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT,
  REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT_FAILURE,
  deleteCustomReportDahsboard,
  REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT,
  REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT_FAILURE,
  shiftCustomReportDahsboard,
  REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT,
  REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT_FAILURE,
  updateCustomReportDashboard,
  REQUEST_ADD_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT,
  REQUEST_ADD_DASHBOARD_CUSTOM_REPORT_FAILURE,
  addCustomReportDashboard,
  REQUEST_DELETE_FIELD_CUSTOM_REPORT,
  RESPONSE_DELETE_FIELD_CUSTOM_REPORT,
  REQUEST_DELETE_FIELD_CUSTOM_REPORT_FAILURE,
  deleteCustomReportField,
  REQUEST_ADD_FIELD_CUSTOM_REPORT,
  RESPONSE_ADD_FIELD_CUSTOM_REPORT,
  REQUEST_ADD_FIELD_CUSTOM_REPORT_FAILURE,
  addCustomReportField,
  REQUEST_UPDATE_FIELD_CUSTOM_REPORT,
  RESPONSE_UPDATE_FIELD_CUSTOM_REPORT,
  REQUEST_UPDATE_FIELD_CUSTOM_REPORT_FAILURE,
  updateCustomReportField,
  REQUEST_SHIFT_FIELD_CUSTOM_REPORT,
  RESPONSE_SHIFT_FIELD_CUSTOM_REPORT,
  REQUEST_SHIFT_FIELD_CUSTOM_REPORT_FAILURE,
  shiftCustomReportField,
  REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT,
  RESPONSE_DOWNLOAD_EXAMPLE_CUSTOM_REPORT,
  REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT_FAILURE,
  downloadExampleCustomReport,
  REQUEST_UPDATE_AXIS_CUSTOM_REPORT,
  RESPONSE_UPDATE_AXIS_CUSTOM_REPORT,
  REQUEST_UPDATE_AXIS_CUSTOM_REPORT_FAILURE,
  updateCustomReportAxis,
};
